import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import { createDiscussion } from "../../../../redux/learner/actions";
import { selectDiscussionSubmitLoading } from "../../../../redux/learner/selector/discussion";

const mapStateToProps = (state: StateType) => ({
  submitLoading: selectDiscussionSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      createDiscussion,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
